import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=5f49685f&scoped=true&"
import script from "./UserNav.vue?vue&type=script&lang=ts&"
export * from "./UserNav.vue?vue&type=script&lang=ts&"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=5f49685f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49685f",
  null
  
)

export default component.exports